// extracted by mini-css-extract-plugin
module.exports = {"errorList":"MissingContractWarningModal_errorList_1DUnY","spinAround":"MissingContractWarningModal_spinAround_3_mVA"};